var $d1d4cf6f433a7805$exports = {};
$d1d4cf6f433a7805$exports = {
    "maximum": `Maksimum`,
    "minimum": `Minimum`
};


export {$d1d4cf6f433a7805$exports as default};
//# sourceMappingURL=tr-TR.mjs.map
